(()=>{
const notice=document.querySelector('[data-cookie-notice]'),open=document.querySelector('[data-cookie-open]');
if(!notice||!open)return;
const choices=[...notice.querySelectorAll('[data-cookie-choice]')],error=notice.querySelector('[data-cookie-error]');
let privacy,busy=false;
function ready(){
 privacy=window.Shopify.customerPrivacy;
 if(!privacy)return;
 document.documentElement.classList.add('bw-custom-consent');
 open.hidden=false;
 const consent=privacy.currentVisitorConsent();
 notice.hidden=['analytics','marketing','preferences'].every(key=>consent[key]==='yes'||consent[key]==='no');
}
open.addEventListener('click',()=>{notice.hidden=false;choices[0].focus()});
choices.forEach(button=>button.addEventListener('click',()=>{
 if(!privacy||busy)return;
 busy=true;error.hidden=true;choices.forEach(b=>b.disabled=true);
 const accept=button.dataset.cookieChoice==='yes';
 const finish=()=>{busy=false;choices.forEach(b=>b.disabled=false)};
 const timer=setTimeout(()=>{finish();error.hidden=false},8000);
 try{privacy.setTrackingConsent({analytics:accept,marketing:accept,preferences:accept},()=>{
  clearTimeout(timer);finish();
  const consent=privacy.currentVisitorConsent(),expected=accept?'yes':'no';
  const saved=['analytics','marketing','preferences'].every(key=>consent[key]===expected);
  notice.dataset.saved=saved?expected:'error';notice.hidden=saved;error.hidden=saved;
 })}catch(e){clearTimeout(timer);finish();error.hidden=false}
}));
let attempts=0;
function load(){
 if(window.Shopify?.customerPrivacy?.currentVisitorConsent){ready();return}
 if(window.Shopify?.loadFeatures){window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],err=>{if(!err||window.Shopify?.customerPrivacy)ready();else if(++attempts<20)setTimeout(load,250)});return}
 if(++attempts<20)setTimeout(load,250);
}
load();
})();
